let previousCart = 0;
let currentCart = 0;

document.addEventListener("DOMContentLoaded", e=>{
  if(typeof(dataLayer) != "undefined"){
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        promiseResult(data);
      });
  }
});

function promiseResult(data){
  previousCart = data;
}

function updateCartQuantity(data, action){
  if(typeof(dataLayer) != "undefined"){
    if(action != "cart"){
      pushToGa4(data);
    }
    else{
      currentCart = data;
      if(previousCart.item_count < currentCart.item_count){
        checkCartChanges();
      }
      previousCart = currentCart;
    }
  }
}

function pushToGa4(product){
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
        items: [
          {
            item_id: product.id,
            item_name: product.title,
            currency: window.Shopify.currency.active,
            price: product.price/100,
            quantity: 1
          }
        ]
    }
  });
}

function checkCartChanges(){
  previousCart.items.forEach(function(previousItem, previousindex){
    let addCart = null;
    let inCart = false;
    currentCart.items.forEach(function(currentItem, currentIndex){
      if(currentItem.id == previousItem.id){
        if(currentItem.quantity > previousItem.quantity){
          pushToGa4(currentItem);
        }
        addCart = null;
      }
      else{
        addCart = currentItem;
      }
    });
    if(addCart != null){
      pushToGa4(addCart);
    }
  });
}